<template>
    <div class="apprentice-simple-card">
        <design-2021-admin-afaq-category-header-component
            :category-in="categoryIn"
            @show-create-faq-modal="showCreateFaqModal"
            @editCategory="editCategory">
        </design-2021-admin-afaq-category-header-component>

        <draggable
            class="questions-list draggable-pages"
            v-if="questionAnswers.length > 0"
            group="questionAnswers"
            :list="questionAnswers"
            @change="orderChanged()"
            ghost-class="drag-host">
            <design-2021-admin-afaq-question-component
                v-for="questionAnswer in questionAnswers"
                :key="questionAnswer.id"
                :question-answer-in="questionAnswer"
                :afaq-tags-in="afaqTagsIn"
                @editQuestion="openEditQuestionModal($event)"
                @question-answer-removed="orderChanged()">
            </design-2021-admin-afaq-question-component>
        </draggable>

        <div
            class="add-faq-question"
            v-if="questionAnswers.length > 0">
            <b-button
                class="btn-add btn-add-faq-question"
                variant="primary"
                @click="showCreateFaqModal">
                {{ $t('admin.new_question_and_answer') }}
            </b-button>
        </div>

        <div
            class="not-found with-header empty-faq-question-list"
            v-if="questionAnswers.length === 0">
            <div
                class="btn-add-circle icon"
                v-b-tooltip.hover
                :title="$t('user_account.new_question_and_answer')"
                @click="showCreateFaqModal"></div>
            <div class="alert-notice">{{ $t('admin.no_questions_found_in_this_category') }}</div>
        </div>

        <design-2021-afaq-edit-question-modal-component
            :ref="'edit-afaq-question-modal'"
            :category-in="categoryIn"
            :afaq-tags-in="afaqTagsIn">
        </design-2021-afaq-edit-question-modal-component>

        <design-2021-afaq-edit-category-modal-component
            :key="categoryIn.id"
            :category-in="categoryIn"
            :ref="`edit-afaq-category-${categoryIn.id}-modal`">
        </design-2021-afaq-edit-category-modal-component>
    </div>
</template>

<script>
import draggable from 'vuedraggable';
import { ords } from '../../../../app';
import $ from 'jquery';

function foreReload(callback) {
    requestAnimationFrame(() => {
        requestAnimationFrame(callback);
    });
}

export default {
    name: 'design-2021-admin-afaq-category-index-component',
    props: ['categoryIn', 'afaqTagsIn'],
    components: {
        draggable,
    },
    computed: {
        questionAnswers() {
            return this.categoryIn.afaq_question_answers;
        },
    },

    methods: {
        editCategory(categoryId) {
            const name = `edit-afaq-category-${categoryId}-modal`;
            this.$refs[name].show();
        },

        openEditQuestionModal(question) {
            this.$refs['edit-afaq-question-modal'].show(question);
        },

        orderChanged() {
            let x = 0;
            let blocks = [];

            for (const question of this.questionAnswers) {
                blocks.push({
                    id: question.id,
                    order: x,
                });
                x++;
            }
            const data = {
                categoryId: this.categoryIn.id,
                blocks: blocks,
            };

            this.axios.post(this.routes.afaqCategoryQuestionOrder(this.categoryIn.id), data).then(
                (response) => {
                    for (const block of blocks) {
                        ords.use('AfaqQuestionAnswer').update({ order: block.order }, block.id);
                    }
                    this.$emit('continue', this.categoryIn.id);
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        showCreateFaqModal() {
            const data = new FormData();
            data.append('categoryId', this.categoryIn.id);
            data.append('question', '');
            data.append('answer', '');
            data.append('order', this.categoryIn.afaq_question_answers.length);
            const headers = { 'Content-Type': 'multipart/form-data' };
            this.alert.saving();

            this.axios.post(this.routes.afaqCategoryQuestion(this.categoryIn.id), data, { headers: headers }).then(
                (response) => {
                    this.categoryIn.addRelation('afaq_question_answers', response.data);
                    this.alert.success();
                    Vue.nextTick(() => {
                        foreReload(() => {
                            const scrollPos = $(`#question-anchor-${response.data.id}`)[0].offsetTop;
                            $('.main-content').animate({ scrollTop: scrollPos }, 500);
                            const faq = this.categoryIn.afaq_question_answers.filter(
                                (question_answer) => question_answer.id === response.data.id,
                            );
                            this.$refs['edit-afaq-question-modal'].show(...faq);
                        });
                    });
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
    },
};
</script>

<style scoped lang="scss">
.add-faq-question {
    margin-top: map-get($grid-gutter-spacing, 'sixty');
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
}
</style>
